import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 143.9 177.2"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.6 69.1C5 62.5 13.4 60 20.3 61.4c5.5 1 9.4 5.9 10.8 11.1 6.3 21.3 12.7 42.7 18.9 64 .3 1.2.9 2.4 1.6 3.5 6.6-21.9 13-43.8 19.5-65.7 1.2-4.7 3.5-9.6 8.1-11.8 7.4-3.4 17.6-1 21.8 6.2 2.7 4.8 2 10.7 0 15.6-9 25-17.8 50.1-26.8 75.2-1.9 4.8-3.7 9.9-7.4 13.7-3.9 3.7-9.6 4.1-14.6 4.1-5.6 0-11.9-.5-16.2-4.6-4-3.8-6-9.1-7.9-14.1-8.9-25.1-17.7-50.3-26.6-75.3-1.7-4.5-2.1-9.8.3-14.1Z",
      style: {"fill":"#504f4e"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M115.5 1.2c5.1-1.6 10.6-1.6 15.7 0 6.3 2 11.3 7.7 12.4 14.2.7 5.6.4 11.8-3 16.6-6.7 9.4-21.2 10.7-30.4 4.3-11.8-8.8-9.3-30.7 5.3-35Z",
      style: {"fill":"#fc0"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "VY-logo"}) } }